module.exports = __webpack_public_path__ + "img/1.e7bda38e.png";